import { render, staticRenderFns } from "./DlgHostDelete.vue?vue&type=template&id=b40dedb8&scoped=true"
import script from "./DlgHostDelete.vue?vue&type=script&lang=js"
export * from "./DlgHostDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40dedb8",
  null
  
)

export default component.exports